import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const ButtonClosedStyled = styled(Button)<{ $minWidth?: string }>`
  background-color: ${colors.neutral.white};
  border: none;
  color: ${colors.blue[600]};
  min-width: ${(props): CSSProp => props.$minWidth || '20rem'};

  &:hover {
    background-color: ${colors.blue[100]};
    color: ${colors.blue[600]};
  }
`;

export const ButtonOpenedStyled = styled(Button)<{ $minWidth?: string }>`
  min-width: ${(props): CSSProp => props.$minWidth || '20rem'};
  border: none;
`;

export const FilterTitle = styled.b`
  margin-left: 1rem;
`;
